export default function BrandLogo({ compact = false, className = "" }) {
  return (
    <span
      className={`easyweb-logo ${compact ? "compact" : ""} ${className}`.trim()}
      aria-hidden="true"
    >
      <svg viewBox="0 0 64 64" focusable="false">
        <defs>
          <linearGradient id={compact ? "easyweb-g-compact" : "easyweb-g"} x1="8" y1="4" x2="58" y2="62" gradientUnits="userSpaceOnUse">
            <stop stopColor="#f6f0ff" />
            <stop offset=".52" stopColor="#b9a5ff" />
            <stop offset="1" stopColor="#7757e8" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="60" height="60" rx="18" fill="#0d0a18" />
        <path d="M17 17h31v8H26v7h18v7H26v8h23v8H17V17Z" fill={`url(#${compact ? "easyweb-g-compact" : "easyweb-g"})`} />
        <path d="M45 17h7L40 55h-7l12-38Z" fill="#e9b96e" />
      </svg>
    </span>
  );
}
